var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndorra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.78262 22.8093C8.36025 23.5721 10.1301 24 12 24C13.8699 24 15.6397 23.5721 17.2174 22.8093L18.2609 12L17.2174 1.19072C15.6397 0.427875 13.8699 0 12 0C10.1301 0 8.36025 0.427875 6.78262 1.19072L5.73914 12L6.78262 22.8093Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2174 22.8089C21.2313 20.868 24 16.7575 24 12C24 7.24251 21.2313 3.13205 17.2174 1.19114V22.8089Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78263 22.8089V1.19114C2.76867 3.13205 0 7.24247 0 12C0 16.7575 2.76867 20.868 6.78263 22.8089Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.1739C12 14.259 12 12 12 12H15.1305V13.5652C15.1305 13.8371 14.6087 14.8335 13.3209 15.6522C12.8332 15.9623 12.3283 16.062 12 16.1739Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86955 8.86954H12V12H8.86955V8.86954Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5652 7.82611C13.5652 7.24978 13.098 6.78262 12.5217 6.78262C12.3314 6.78262 12.1536 6.83437 12 6.92334C11.8464 6.83437 11.6686 6.78262 11.4783 6.78262C10.902 6.78262 10.4348 7.24978 10.4348 7.82611H7.82611V13.0434C7.82611 14.9857 9.36858 16.109 10.5782 16.6913C10.4877 16.8459 10.4348 17.0253 10.4348 17.2174C10.4348 17.7937 10.902 18.2609 11.4783 18.2609C11.6686 18.2609 11.8464 18.2092 12 18.1202C12.1536 18.2092 12.3314 18.2609 12.5217 18.2609C13.098 18.2609 13.5652 17.7937 13.5652 17.2174C13.5652 17.0253 13.5123 16.8459 13.4218 16.6913C14.6314 16.109 16.1739 14.9858 16.1739 13.0434V7.82611H13.5652ZM14.6087 13.0434C14.6087 13.3154 14.6087 14.1427 13.3209 14.9615C12.8332 15.2716 12.3283 15.4727 12 15.5845C11.6717 15.4727 11.1668 15.2716 10.6791 14.9615C9.39131 14.1427 9.39131 13.3154 9.39131 13.0434V9.39131H14.6087V13.0434Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndorra);
export default __webpack_public_path__ + "static/media/andorra.8fac7362d4a01499750bc1f242eb42f9.svg";
export { ForwardRef as ReactComponent };